import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { OverlayPanel } from "primereact/overlaypanel";
import { Button } from "primereact/button";
import { Carousel } from "primereact/carousel";
import Helpers from "../../../../utils/helpers";

const GridPanel = (props: any) => {
  var navigate = useNavigate();
  const [gridDatas, setGridDatas] = useState<any[]>([]);
  const responsiveOptions = [
    {
      breakpoint: "1199px",
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: "991px",
      numVisible: 1,
      numScroll: 1,
    },
    {
      breakpoint: "767px",
      numVisible: 1,
      numScroll: 1,
    },
  ];

  useEffect(() => {
    if (props && props.filteredItems && props.filteredItems.length > 0) {
      setGridDatas(props.filteredItems);
    }
  }, [props]);
  const DetailsOverlay = (data: any) => {
    const selectDaysDpDown = useRef<any>(null);
    return (
      <>
        <i
          className="pi pi-ellipsis-v"
          style={{ fontSize: "1em", cursor: "pointer" }}
          onClick={(e) => selectDaysDpDown.current.toggle(e)}
        ></i>
        <OverlayPanel ref={selectDaysDpDown}>
          <Button
            onClick={() => {
              navigate(
                `/aura-camera/operation-details/${data?.row?.siteID}/${data?.row?.createdOn}`
              );
            }}
          >
            Details
          </Button>
        </OverlayPanel>
      </>
    );
  };
  const productTemplate = (gridData: any) => {
    return (
      <>
        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div className="card panel-box">
            <div className="card-header">
              <h6>{gridData.siteName}</h6>
              <div className="dropdown">
                <DetailsOverlay row={gridData} />
              </div>
            </div>
            <div className="card-body">
              <ol>
                <li>
                  <div className="list-title">Area</div>
                  <div className="list-value">{gridData?.area}</div>
                </li>
                <li>
                  <div className="list-title">Date</div>
                  <div className="list-value">
                    {Helpers.ConvertUtcToLocalReadable(gridData?.createdOn)}
                  </div>
                </li>
                <li>
                  <div className="list-title">Camera Operator</div>
                  <div className="list-value">{gridData?.operator}</div>
                </li>
                <li>
                  <div className="list-title">Camera Name</div>
                  <div className="list-value">{gridData?.cameraID}</div>
                </li>
                <li>
                  <div className="list-title">Leaks Count</div>
                  <div className="list-value">{gridData?.totalLeaks}</div>
                </li>
              </ol>
            </div>
          </div>
        </div>
      </>
    );
  };
  return (
    <>
      <Carousel
        value={gridDatas}
        numVisible={3}
        numScroll={1}
        responsiveOptions={responsiveOptions}
        itemTemplate={productTemplate}
      />
    </>
  );
};

export default GridPanel;
